import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { userRepository } from "../application/UserRepository";
import { authClient } from "@/openbaas";
import {
  useGetShopper,
  useGetAdmin,
} from "@/backend/store/infrastructure/useStore";

export function useUser() {
  const queryClient = useQueryClient();
  // Crear usuario
  const user = useQuery({
    //7 dias

    queryKey: ["users"], // La clave de consulta para los usuarios
    queryFn: async () => {
      const session = await authClient.getSession();
      return session.data;
    }, // Asegúrate de que esta función exista en tu repositorio
  });

  //@ts-ignore
  const { data: shopper } = useGetShopper(user.data?.user.email);

  //@ts-ignore
  const { data: admin } = useGetAdmin(user.data?.user.email);
  // Actualizar usuario
  const { isPending, ...updateUser } = useMutation({
    mutationFn: (user: Partial<User>) => {
      return userRepository.update({ ...user, id: user.id });
    },
    onSuccess: () => {
      user.refetch();
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
    onError: (error) => {
      console.error("Error updating user:", error);
    },
  });

  return {
    shopper,
    admin,
    isAdmin: !!admin,
    user: user.data?.user,
    session: user.data?.session,
    updateUser: updateUser.mutateAsync,
  };
}
